export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8172.b320c49b.jpg";